var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 24,
    fill: "#3C3C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 42,
    width: 70,
    height: 50,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 42H43V45C43 46.6569 41.6569 48 40 48C38.3431 48 37 46.6569 37 45V42Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42H37V39C37 37.3431 38.3431 36 40 36C41.6569 36 43 37.3431 43 39V42Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42H84V39C84 37.3431 85.3431 36 87 36C88.6569 36 90 37.3431 90 39V42Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 42H90V45C90 46.6569 88.6569 48 87 48C85.3431 48 84 46.6569 84 45V42Z",
    fill: "#3C3C3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 64,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 75,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 53,
    width: 11,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 64,
    width: 11,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 75,
    width: 11,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 53,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 64,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.428ca7e2b95c75651bc1a715f5ac95e3.svg";
export { ForwardRef as ReactComponent };